import React from "react";
import { Spinner } from "./Spinner";

type ButtonProps = {
    className?: string;
    text?: string;
    variant?: "primary" | "secondary";
    type?: "submit" | "reset" | "button";
    disabled?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    isError?: boolean;
    isLoading?: boolean;
    img?: React.ReactNode;
}

export function Button({ className, text, variant = "primary", type, disabled, onClick, isLoading, img }: ButtonProps) {
    const handleStyles = () => {
        const disabledStyle = `bg-gray-300 text-gray-500 cursor-not-allowed ${img ? "" : "focus:ring-[##ef4444]"}`;
        const primaryStyle = `bg-[#52ae30] text-white hover:bg-green-700 ${img ? "" : "focus:ring-[#52ae30]"}`;
        const secondaryStyle = `bg-gray-500 text-white hover:bg-gray-600 ${img ? "" : "focus:ring-[#52ae30]"} mr-2`;

        if (disabled) {
            return disabledStyle;
        } else if (variant === "primary") {
            return primaryStyle;
        } else if (variant === "secondary") {
            return secondaryStyle
        }
    };

    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`px-6 py-2 rounded-full font-semibold transition duration-150 ease-in-out ${img ? "" : "focus:outline-none focus:ring-2 focus:ring-offset-2"} ${handleStyles()} ${className}`}>
          {isLoading ?
            <Spinner />
            : img ?
              <div className="flex flex-row items-center justify-center gap-x-2">
                  <div>{img}</div>
                  <span>{text}</span>
              </div>
              : text}
      </button>
    )
}
